import { render, staticRenderFns } from "./transmit.vue?vue&type=template&id=eafc4598&"
import script from "./transmit.vue?vue&type=script&lang=ts&"
export * from "./transmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "transmit.vue"
export default component.exports